import Map from '../Map/Map';
import InvestProRegions from '../Layers/InvestProLayers/InvestProRegions.jsx';
import InvestProDistricts from '../Layers/InvestProLayers/InvestProDistricts.jsx';
import InvestProDotsLayer from '../Layers/InvestProLayers/InvestProDotsLayer.jsx';

function MapBlock() {
  const widgets = (
    <>
      <InvestProRegions />;
      <InvestProDistricts />
      <InvestProDotsLayer />
    </>
  );

  return (
    <>
      <Map />
      {widgets}
    </>
  );
}

export default MapBlock;
